import { Trans } from 'react-i18next';
import React, { useMemo, useCallback } from 'react';

import { L2PayModal } from '@/components';
import { useCurrentUserId, formatNum, L2TxReqParams } from '@/utils';
import { SETTLEMENT_ADDRESS } from '@/consts';

import style from './index.module.scss';

export const PayArticleModal = ({
  articleId,
  price,
  turnOff,
  message,
  onSubmit,
}: {
  articleId: number;
  price?: number;
  turnOff: () => void;
  message: string;
  onSubmit: (tx: L2TxReqParams) => Promise<any>;
}) => {
  const currentAddress = useCurrentUserId();

  const _price = useMemo(() => `$${formatNum((price || 0) / 10000)}`, [price]);

  const txParams = useMemo(
    () =>
      price && currentAddress
        ? {
            price: price,
            message: `Pay ${_price} to view ${message} ​https://debank.com/stream/${articleId}`,
            senderAddr: currentAddress,
            receiverAddr: SETTLEMENT_ADDRESS,
          }
        : undefined,
    [currentAddress, articleId, _price, price, message],
  );

  const payTitle = useMemo(
    () => (
      <div className={style.payTitle}>
        <Trans i18nKey="ArticleContent_PayArticleModal.1pqg" values={{ _price, message }}>
          Pay <span className={style.payTitleWeight}>{_price}</span> to view {message}
        </Trans>
        <div className={style.payTitleWeight}>https://debank.com/stream/{articleId}</div>
      </div>
    ),
    [articleId, _price, message],
  );

  const handlePaySubmit = useCallback(
    async ({ tx }) => {
      onSubmit(tx);
    },
    [onSubmit],
  );

  return (
    <L2PayModal
      turnOff={turnOff}
      txParams={txParams}
      payTitle={payTitle}
      onPaySubmit={handlePaySubmit}
    />
  );
};
